module.exports = __webpack_public_path__ + "img/check-blue-icon.ff72374b.svg";